module.exports = __webpack_public_path__ + "static/media/ico-footer-2.fdd3b299.svg";